import { render, staticRenderFns } from "./lmsConfirm.vue?vue&type=template&id=6e88f57f&"
import script from "./lmsConfirm.vue?vue&type=script&lang=js&"
export * from "./lmsConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports